<template>
	<p class="dp-f">
		<span>{{ text }}</span>
		<tool-tip :visiable="visiable" :content="content" class="upload-tip dp-f">
			<img
				@mouseenter="visiable = true"
				@mouseout="visiable = false"
				src="../../images/doubt.png"
				alt
			/>
		</tool-tip>
	</p>
</template>
<script>
export default {
	props: {
		text: {
			type: String,
			default: Constants.PRICING_NEW_COMMON_LIMIT,
		},
		content: {
			type: String,
			default: Constants.PRICING_NEW_TAP_PRO_TIPS,
		},
	},
	data() {
		return {
			visiable: false,
		}
	},
}
</script>
<style lang="scss" scoped>
.dp-f {
	display: flex;
	justify-content: center;
	align-items: center;
}
.upload-tip {
	margin-left: 4px;
	line-height: 100%;
	position: relative;
	cursor: pointer;
	>>> .nut-tool-tips {
		text-indent: 0;
	}
}
</style>
